export default class EnvUtils {

  static isdev() {
    let location = window.location;
    switch (location.hostname) {
      case "locaite.caite.io":
        return false
    }
    return true
  }

}
